export default {
  apiKey: 'AIzaSyAc8hUuqEpE4cp6BFrCECtCq5tcyFc0Fyw',
  authDomain: 'mobile-dtg.firebaseapp.com',
  projectId: 'mobile-dtg',
  storageBucket: 'mobile-dtg.appspot.com',
  messagingSenderId: '870990543991',
  appId: '1:870990543991:web:ad8d0c4d870b0d4e4f9a72',
  measurementId: 'G-H9E7BR6TST'
}
